import OutsideEyeContext from "./context.js"
import React from "react"

const usePressOutsideContext = () => React.useContext(OutsideEyeContext)

export default usePressOutsideContext
